var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UnPatrolListComponent',{attrs:{"typeName":"品質巡回 クレーム対応 未点検一覧","type":1,"settionStrageName":"ClaimUnpatrolListStorageItemName","claim":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }